const commonImages = {
  weekByWeek: {
    4: {
      src: require('./week-by-week/Week-4.jpg'),
      alt:
        "Sprinkle: The start of the embryonic period. The bun's in the oven!",
    },
    5: {
      src: require('./week-by-week/Week-5.jpg'),
      alt: 'Sugar Cube: Your first missed period and positive pregnancy test',
    },
    6: {
      src: require('./week-by-week/Week-6.jpg'),
      alt: "Candied Pine Nuts: Baby's heart is beating alongside yours now!",
    },
    7: {
      src: require('./week-by-week/Week-7.jpg'),
      alt: 'Jelly Bean: Think fast, brain cells are forming like crazy!',
    },
    8: {
      src: require('./week-by-week/Week-8.jpg'),
      alt:
        'Jordan Almonds: Your baby has developed limbs and is moving and grooving.',
    },
    9: {
      src: require('./week-by-week/Week-9.jpg'),
      alt: 'Maraschino Cherry: So long embryonic period. Your baby is a fetus!',
    },
    10: {
      src: require('./week-by-week/Week-10.jpg'),
      alt: 'Cake Pop: Can you finally see your bump?',
    },
    11: {
      src: require('./week-by-week/Week-11.jpg'),
      alt:
        "Macaroon: Baby's facial bones and features are coming into the picture.",
    },
    12: {
      src: require('./week-by-week/Week-12.jpg'),
      alt: 'Blossom Cookie: The basics are all here, time to get growing!',
    },
    13: {
      src: require('./week-by-week/Week-13.jpg'),
      alt:
        'Madeleine: So long to the first trimester! (and maybe goodbye morning sickness!)',
    },
    14: {
      src: require('./week-by-week/Week-14.jpg'),
      alt:
        "Ice Cream Sandwich: Second trimester: most moms' favorite part of pregnancy.",
    },
    15: {
      src: require('./week-by-week/Week-15.jpg'),
      alt: 'Cupcake: Bright future ahead, baby can now see and react to light!',
    },
    16: {
      src: require('./week-by-week/Week-16.jpg'),
      alt:
        'Beignet: Your baby can hear and recognize your voice, loud and clear!',
    },
    17: {
      src: require('./week-by-week/Week-17.jpg'),
      alt:
        'Flan: Mood swings, weird dreams, awesome hair - all because of hormones.',
    },
    18: {
      src: require('./week-by-week/Week-18.jpg'),
      alt: 'Coffee Cake: Hiyah! Can you feel those kicks yet?',
    },
    19: {
      src: require('./week-by-week/Week-19.jpg'),
      alt:
        "Lava Cake: The standard ultrasound is coming up! What' your guess: boy or girl?",
    },
    20: {
      src: require('./week-by-week/Week-20.jpg'),
      alt: "Jumbo Eclair: Your baby's first photoshoot was a success!",
    },
    21: {
      src: require('./week-by-week/Week-21.jpg'),
      alt: 'Two Jelly Donuts: Your sneak peek into third trimester symptoms.',
    },
    22: {
      src: require('./week-by-week/Week-22.jpg'),
      alt:
        'Caramel Apple: That bump is getting big! Is your bellybutton an outie yet?',
    },
    23: {
      src: require('./week-by-week/Week-23.jpg'),
      alt:
        'Bear Claw: Now hear this, baby can recognize sounds and sense your movement!',
    },
    24: {
      src: require('./week-by-week/Week-24.jpg'),
      alt: "Cinnamon Roll: Baby's skin is turning pink and soft, too cute!",
    },
    25: {
      src: require('./week-by-week/Week-25.jpg'),
      alt:
        "A Slice of Pie: Your partner can hear baby's heartbeat against your belly.",
    },
    26: {
      src: require('./week-by-week/Week-26.jpg'),
      alt: "Peach Cobbler: Your baby's eyes are open and letting the light in!",
    },
    27: {
      src: require('./week-by-week/Week-27.jpg'),
      alt: 'Banana Split: Say goodbye to trimester two!',
    },
    28: {
      src: require('./week-by-week/Week-28.jpg'),
      alt:
        "Steamed Pudding: Month seven, trimester three, you're in the home stretch!",
    },
    29: {
      src: require('./week-by-week/Week-29.jpg'),
      alt:
        'Cinnamon Bread: Baby is growing fast and sitting right on your digestive tract.',
    },
    30: {
      src: require('./week-by-week/Week-30.jpg'),
      alt: "Raspberry Galette: Your baby's brain is getting super complex!",
    },
    31: {
      src: require('./week-by-week/Week-31.jpg'),
      alt: 'Banana Bread: Full nights of sleep may be a thing of the past.',
    },
    32: {
      src: require('./week-by-week/Week-32.jpg'),
      alt:
        "Zucchini Bread: Embrace your nesting instinct, but don't let it stress you out!",
    },
    33: {
      src: require('./week-by-week/Week-33.jpg'),
      alt:
        "Souffle: This is the story all about how baby's life got flipped - turned upside down!",
    },
    34: {
      src: require('./week-by-week/Week-34.jpg'),
      alt:
        "Sweet Bread: Your baby knows your voice and your partner's. Sing a song together!",
    },
    35: {
      src: require('./week-by-week/Week-35.jpg'),
      alt: "Nutella Bread: Be prepared - it's time to set up your birth plan.",
    },
    36: {
      src: require('./week-by-week/Week-36.jpg'),
      alt: 'Trifle: One month left, welcome to early term!',
    },
    37: {
      src: require('./week-by-week/Week-37.jpg'),
      alt: 'Carrot Cake: Get the basic preparations done and then relax!',
    },
    38: {
      src: require('./week-by-week/Week-38.jpg'),
      alt:
        "Pineapple Upside-Down Cake: It's natural to be nervous - hang in there, mom!",
    },
    39: {
      src: require('./week-by-week/Week-39.jpg'),
      alt: 'Apple Pie: You are in term pregnancy! Watch for signs of labor!',
    },
    40: {
      src: require('./week-by-week/Week-40.jpg'),
      alt: 'Cheesecake: The big day has arrived!',
    },
    41: {
      src: require('./week-by-week/Week-41.jpg'),
      alt:
        "Bundt Cake: Late-term pregnancy - your baby's getting born before the end of next week.",
    },
    42: {
      src: require('./week-by-week/Week-42.jpg'),
      alt: 'Birthday Cake: You made it!',
    },
    main: {
      src: require('./week-by-week/Main-image.png'),
      alt:
        'Bump Boxes 40 week pregnancy updates showing various cartoon drawings of food items.',
    },
  },
};

export default commonImages;
